import React, { useState, useEffect } from 'react';
import { Clock, CheckCircle, XCircle, TrendingUp, TrendingDown, DollarSign, Copy, ExternalLink, Search, BarChart2 } from 'lucide-react';
import { apiFetch } from '../App';

const T = { bg2:'#0d1114', border:'rgba(255,255,255,.06)', text:'#e8eaeb', muted:'#4a5a63', green:'#00c566' };

export default function Markets() {
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    apiFetch('/api/creator/markets').then(setMarkets).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  const filtered = markets.filter(m => {
    const ms = m.question.toLowerCase().includes(search.toLowerCase());
    const mf = filter==='all'||(filter==='active'&&m.state===0)||(filter==='resolved'&&m.state===1)||(filter==='cancelled'&&m.state===2);
    return ms && mf;
  });

  const stateColor = {0:'#00c566',1:'#f5c842',2:'#ff4444'};
  const stateLabel = {0:'Active',1:'Resolved',2:'Cancelled'};
  const StateIcon  = {0:Clock,1:CheckCircle,2:XCircle};

  return (
    <div>
      <h1 style={{ fontSize:'clamp(20px,4vw,28px)', fontWeight:800, marginBottom:4 }}>My Markets</h1>
      <p style={{ fontSize:14, color:T.muted, marginBottom:20 }}>All prediction markets you've created</p>

      <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:20 }}>
        <div style={{ position:'relative', flex:'1 1 200px' }}>
          <Search size={14} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:T.muted }}/>
          <input placeholder="Search markets..." value={search} onChange={e=>setSearch(e.target.value)} style={{ paddingLeft:36 }}/>
        </div>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
          {['all','active','resolved','cancelled'].map(f=>(
            <button key={f} onClick={()=>setFilter(f)}
              style={{ padding:'8px 14px', borderRadius:8, border:`1px solid ${filter===f?'rgba(0,197,102,.3)':T.border}`, background:filter===f?'rgba(0,197,102,.08)':'rgba(255,255,255,.03)', color:filter===f?T.green:T.muted, cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'inherit', textTransform:'capitalize' }}>
              {f}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:40, color:T.muted }}>Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:48, textAlign:'center', color:T.muted }}>
          <BarChart2 size={30} style={{ marginBottom:12, opacity:.4 }}/>
          <div style={{ fontSize:15, fontWeight:600, marginBottom:4 }}>No markets found</div>
          <div style={{ fontSize:13 }}>Create your first market to start earning royalties</div>
        </div>
      ) : filtered.map(m => {
        const SI = StateIcon[m.state]||Clock;
        return (
          <div key={m.id} style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:18, marginBottom:12 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12, marginBottom:12 }}>
              <div style={{ fontSize:14, fontWeight:600, lineHeight:1.5, flex:1 }}>{m.question}</div>
              <div style={{ display:'flex', gap:8, flexShrink:0 }}>
                <button onClick={()=>navigator.clipboard?.writeText(`https://app.naijapredict.net/dollar/market/${m.id}`)}
                  style={{ width:32, height:32, borderRadius:8, background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:T.muted }}>
                  <Copy size={13}/>
                </button>
              </div>
            </div>
            <div style={{ height:6, background:'rgba(255,255,255,.06)', borderRadius:3, overflow:'hidden', marginBottom:8 }}>
              <div style={{ height:'100%', width:(m.yesPct||50)+'%', background:'linear-gradient(90deg,#00c566,#f5c842)', borderRadius:3 }}/>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, marginBottom:12 }}>
              <span style={{ color:T.green, fontWeight:600 }}>YES {m.yesPct||50}%</span>
              <span style={{ color:'#ff4444', fontWeight:600 }}>NO {m.noPct||50}%</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:T.muted }}>
              <span style={{ display:'flex', alignItems:'center', gap:4, color:stateColor[m.state], fontWeight:600 }}>
                <SI size={11}/>{stateLabel[m.state]}
              </span>
              <span>Pool: ${parseFloat(m.totalCollateral||0).toFixed(2)} USDC</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
